/**
 * @desc 服务器系统时间
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type GetSystemTimeParameter = never

const method = 'GET'
const url = '/system/base/systemTime'

export const getSystemTimeApi = (
  params?: GetSystemTimeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    params,
    ...config
  })
}

getSystemTimeApi.method = method
getSystemTimeApi.url = url
